import React, { useState } from 'react';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';
import { Star } from 'lucide-react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GigReviewDialog({ gigId, open, onOpenChange, onReviewed }) {
  const { language } = useLanguage();
  const tr = (lv, en, ru) => (language === 'lv' ? lv : language === 'ru' ? ru : en);
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (rating < 1) {
      toast.error(tr('Lūdzu izvēlies vērtējumu', 'Please pick a rating', 'Выберите оценку'));
      return;
    }
    setSaving(true);
    try {
      await axios.post(`${API}/gigs/${gigId}/review`, { rating, comment: comment || null }, { withCredentials: true });
      toast.success(tr('Paldies par atsauksmi!', 'Thanks for your review!', 'Спасибо за отзыв!'));
      onOpenChange(false);
      onReviewed?.();
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : tr('Neizdevās', 'Failed', 'Ошибка'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="gig-review-dialog">
        <DialogHeader>
          <DialogTitle className="font-outfit">{tr('Novērtē darbu', 'Rate this gig', 'Оцените работу')}</DialogTitle>
        </DialogHeader>
        <div className="flex justify-center gap-1 py-4" data-testid="star-rating">
          {[1, 2, 3, 4, 5].map((s) => (
            <button key={s} type="button" onMouseEnter={() => setHover(s)} onMouseLeave={() => setHover(0)}
              onClick={() => setRating(s)} data-testid={`star-${s}`}>
              <Star className={`w-9 h-9 transition-colors ${(hover || rating) >= s ? 'fill-[#D97736] text-[#D97736]' : 'text-[#E5E4E0]'}`} />
            </button>
          ))}
        </div>
        <Textarea value={comment} onChange={(e) => setComment(e.target.value)} rows={3}
          placeholder={tr('Pastāsti par savu pieredzi (neobligāti)...', 'Tell us about your experience (optional)...', 'Расскажите о вашем опыте...')}
          data-testid="review-comment-input" />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="border-[#E5E4E0] text-[#5C5C5C]">
            {tr('Atcelt', 'Cancel', 'Отмена')}
          </Button>
          <Button onClick={submit} disabled={saving} className="bg-[#D97736] hover:bg-[#C06528] text-white" data-testid="submit-review-btn">
            {saving ? tr('Sūta...', 'Sending...', 'Отправка...') : tr('Iesniegt', 'Submit', 'Отправить')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
